module.exports = __webpack_public_path__ + "img/14-02.795a0994.png";